import { css } from 'lit';
export default css `
  :host {
    display: flex;
    flex-direction: row;
    gap: var(--wui-spacing-l);
    width: 100%;
    border-radius: var(--wui-border-radius-xs);
  }
`;
//# sourceMappingURL=styles.js.map